//#region src/properties/composeHomeRows.ts
var e = 8, t = {
	recently_viewed: 0,
	saved_stays: 1,
	because_you_viewed: 2,
	back_to_destination: 4
}, n = [
	"recently_viewed",
	"saved_stays",
	"because_you_viewed",
	"back_to_destination"
], r = (e) => {
	for (let t = e.length - 1; t >= 0; --t) if (e[t].kind !== "featured_listings") return t;
	return -1;
}, i = ({ publicRows: e, personalRows: i }) => {
	let a = e.filter((e) => e.cards.length > 0), o = i.filter((e) => e.cards.length > 0), s = /* @__PURE__ */ new Map();
	for (let e of n) {
		let n = o.find((t) => t.kind === e);
		if (!n) continue;
		let r = Math.min(t[e], a.length), i = s.get(r);
		i ? i.push(n) : s.set(r, [n]);
	}
	let c = [];
	for (let e = 0; e <= a.length; e += 1) c.push(...s.get(e) ?? []), e < a.length && c.push(a[e]);
	for (; c.length > 8;) {
		let e = r(c);
		if (e === -1) break;
		c.splice(e, 1);
	}
	return c;
};
//#endregion
export { e as MAX_HOME_ROWS, i as composeHomeRows };
